import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'reservationStatus',
  standalone: false,
})
export class ReservationStatusPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.RESERVATION_STATUS_RECEPTION:
      type = this.translate.instant(AppConst.RESERVATION_STATUS_RECEPTION_TEXT);
      break;
      case AppConst.RESERVATION_STATUS_COMPLETE:
      type = this.translate.instant(AppConst.RESERVATION_STATUS_COMPLETE_TEXT);
      break;
      case AppConst.RESERVATION_STATUS_CANCEL:
      type = this.translate.instant(AppConst.RESERVATION_STATUS_CANCEL_TEXT);
      break;
      case AppConst.RESERVATION_STATUS_LOST:
      type = this.translate.instant(AppConst.RESERVATION_STATUS_LOST_TEXT);
      break;
    }
    return type;
  }
}
